import React, { useMemo, useState, useEffect } from 'react';
import { FormGroup, ControlLabel, Panel } from 'react-bootstrap';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import SelectVirtualized from '../../../../../../components/Select/Virtualized';

const ViewUser = ({ item, languages, fetchPreview, isSuperAdminEdit }) => {
  const { preview } = item;

  const selectoptions = useMemo(() => languages?.map((lang) => ({ ...lang, value: lang.code, label: lang.name })), [languages]);

  const [selectedLanguage, setSelectedLanguage] = useState(null);

  const previewBody = useMemo(() => {
    if (isSuperAdminEdit) {
      return `<div id="notification-preview" contenteditable="true">${preview?.body_raw}</div>`;
    }
    return preview?.body;
  }, [isSuperAdminEdit, preview.body, preview.body_raw])

  const subject = useMemo(() => {
    if (isSuperAdminEdit) {
      return `<div id="notification-subject" contenteditable="true">${preview?.subject}</div>`;
    }
    return preview?.subject;
  }, [isSuperAdminEdit, preview.subject])

  const onChangeLanguage = (lang) => {
    setSelectedLanguage(lang);
    fetchPreview(item.id, { lang_code: lang.value });
  };

  useEffect(() => {
    if (preview?.lang_code) {
      const finded = selectoptions?.find((lang) => lang.value === preview?.lang_code);
      if (finded) {
        setSelectedLanguage(finded);
      } else {
        setSelectedLanguage(selectoptions?.[0]);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [preview?.lang_code, selectoptions]);

  return (
    <>
      <FormGroup>
        <ControlLabel>Language</ControlLabel>
        <SelectVirtualized
          components={{ IndicatorSeparator: null }}
          onChange={onChangeLanguage}
          noOptionsMessage={() => 'Language not found'}
          hideSelectedOptions={false}
          value={selectedLanguage}
          options={selectoptions}
          name="language_code"
          placeholder="Choose language"
        />
      </FormGroup>
      <FormGroup className="form-group__preview mb-0">
        <ControlLabel htmlFor="preview">Preview</ControlLabel>
        <Panel
          className={classNames({
            'mb-0': !isSuperAdminEdit,
          })}
          dir={selectedLanguage?.direction || 'ltr'}
        >
          <Panel.Heading dangerouslySetInnerHTML={{ __html: subject || '' }} />
          <Panel.Body className="p-0">
            <div
              onInput={(e) => console.log('Text inside div', e.currentTarget.textContent)}
              className="preview-wrapper"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
              dangerouslySetInnerHTML={{ __html: previewBody || '' }}
              dir={selectedLanguage?.direction || 'ltr'}
            />
          </Panel.Body>
        </Panel>
      </FormGroup>
    </>
  );
};

ViewUser.propTypes = {
  item: PropTypes.object,
  languages: PropTypes.array,
  fetchPreview: PropTypes.func,
  isSuperAdminEdit: PropTypes.bool,
};

export default ViewUser;
